import { BadRequest } from 'http-errors';

export const tryParseJson = <T = any>(jsonString: string | undefined | null) => {
  if (!jsonString) { throw new Error('JSON cannot be empty'); }
  try {
    return JSON.parse(jsonString) as T;
  } catch (_err) {
    throw new Error('JSON has to be valid.');
  }
};

export const tryParseJsonBody = <T = any>(bodyToParse: string | undefined | null) => {
  try {
    return tryParseJson(bodyToParse) as T;
  } catch (err) {
    throw new BadRequest((err as Error).message);
  }
};
